import React from 'react';
import { Field, inputClass } from './BackgroundFields';
import { resolveShapeRadius } from '../utils/colorFillUtils';

export default function ShapeFields({
  shape,
  borderRadius,
  onChangeShape,
  onChangeRadius,
  preview,
  previewLabel = 'Aperçu',
}) {
  const radius = resolveShapeRadius(shape, borderRadius);
  const showRadiusSlider = shape === 'custom' || shape === 'rounded';

  return (
    <>
      <Field label="Forme">
        <select className={inputClass} value={shape || 'rounded'} onChange={onChangeShape}>
          <option value="square">Carré</option>
          <option value="rounded">Arrondi</option>
          <option value="pill">Pilule</option>
          <option value="circle">Rond</option>
          <option value="custom">Personnalisé</option>
        </select>
      </Field>

      {showRadiusSlider ? (
        <Field
          label={`Arrondi des coins (${shape === 'rounded' ? borderRadius ?? 12 : borderRadius ?? 0}px)`}
        >
          <input
            type="range"
            min="0"
            max="80"
            value={shape === 'rounded' ? borderRadius ?? 12 : borderRadius ?? 0}
            onChange={onChangeRadius}
            className="w-full"
          />
        </Field>
      ) : null}

      {preview ? (
        <div className="rounded-lg border border-border p-4 bg-muted/20 flex flex-col items-center gap-2">
          <span className="text-xs font-medium text-muted-foreground self-start">{previewLabel}</span>
          {preview(radius)}
        </div>
      ) : null}
    </>
  );
}
